// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

interface IMedicalDocumentPayload {
  id: string
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends ApiService {
  getMedicalDocument(payload: IMedicalDocumentPayload, policy_slug: string): Promise<any> {
    return this.post(`/v2/policy/${policy_slug}/action/download_medical`, payload, { observe: 'response', responseType: 'blob', withCredentials: true }).toPromise();
  }

  saveFile(data: any, fallbackFilename: string) {
    let header = data.headers.get('Content-Disposition');
    let fileName = header.split('=')[1] ? header.split('=')[1].replace(/"/g, '') : fallbackFilename;
    let blob = new Blob([data.body], { type: 'application/pdf' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }
}
